<template>
  <section v-if="order != null">
    <CartDisplay
      v-if="order.items.length > 0"
      :order="order"
      :loading="loadingOrder"
    />

    <CartEmpty v-else />
  </section>
</template>

<script>
import Api from './cart_api'
import CartEmpty from './empty_display'
import CartDisplay from './h4h_cart_display'


export default {
  components: {
    CartDisplay,
    CartEmpty,
  },

  data() {
    return {
      loadingOrder: false,
      order: null,
    }
  },

  computed: {
    invalidItems() {
      if (this.order) {
        return this.order.items.filter(item => {
          return item.hotel_id == null && item.package_hotel_required
        })
      } else {
        return []
      }
    },

    invalidItemsInCart() {
      return this.invalidItems.length > 0
    }
  },

  created() {
    this.getOrder()
    let divListener = Api.cartChangeElement()

    if (divListener) {
      divListener.addEventListener(Api.cartChangeEventName(), this.getOrder)
    }
  },
  updated(){
    if(this.order.cart_version==='h4h' && this.order.items.length===0 &&
    document.getElementById('h4hHotelIndex')){
      window.location.replace('/calendar-of-events')
    }
  },

  methods: {
    getOrder() {
      this.loadingOrder = true
      return Api.getOrder().then(order => {
        if (order.id) {
          this.order = order

          // Notify of any amount changes.
          // Used on checkout page to process charge
          this.$emit('amount-update',
            { amountDecorated: order.amount_due_today_decorated,
              amount: order.amount_due_today,
              currency: order.charge_currency,
              itemCount: order.item_count,
              invalidItemsInCart: this.invalidItemsInCart,
              orderId: order.id,
              cart_version: order.cart_version })
        }

        // Update Navbar Badge
        if (order.item_count) {
          document.getElementById('badge').innerHTML = order.item_count
        } else {
          document.getElementById('badge').innerHTML = ''
        }

        this.loadingOrder = false
      }).catch(() => { this.loadingOrder = false })
    }
  }
}
</script>
